import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/sections/about/view/about-view.js");
